export default __webpack_public_path__ + "static/media/pic4.3f284472.png";